// import axios from "axios";
// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { useToast } from "../Toast/ToastContext"; // Ensure this is correctly set up in your project
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import ApiUrl from "./../Environment/ApiUrl"; // Ensure this points to your API base URL
// import "../../assets/css/Loader.css";

// function Order() {
//   const navigate = useNavigate();
//   const toast = useToast();

//   // State management
//   const [loading, setLoading] = useState(false);
//   const [activeTab, setActiveTab] = useState("by-customer");
//   const [responseData, setResponseData] = useState([]);
//   const [deleteShowModals, setDeleteShowModals] = useState(false);
//   const [getdeleteid, setdeleteid] = useState("");
//   const [getdeletename, setdeletename] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [showAllItems, setShowAllItems] = useState(false);

//   const [searchTerm, setSearchTerm] = useState("");

//   // Fetch data on component mount
//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.get(`${ApiUrl}/Api/orders.php`);
//       const data = response.data.data || [];

//       setTimeout(() => {
//         setLoading(false);
//       }, 1000);
//       setResponseData(data);
//     } catch (error) {
//       console.error("Error fetching data:", error.message);
//       setResponseData([]);
//             setLoading(false);
//       toast.error("Failed to fetch data", 3000, "topRight");
//     }
//   };

//   // Format date to DD-MM-YYYY
//   const formatDate = (dateString) => {
//     if (!dateString) return "";
//     const date = new Date(dateString);
//     if (isNaN(date.getTime())) return dateString;

//     const day = String(date.getDate()).padStart(2, "0");
//     const month = String(date.getMonth() + 1).padStart(2, "0");
//     const year = date.getFullYear();
//     return `${day}-${month}-${year}`;
//   };

//   // Handle tab switching
//   const handleTabClick = (tab) => {
//     setActiveTab(tab);
//     setCurrentPage(1); // Reset to first page when switching tabs
//   };

//   // Handle update order navigation
//   const handleUpdateOrder = (id) => {
//     navigate(`/update-order/${id}`);
//   };

//   // Delete functionality
//   const handleOpenModal = (id, order_no) => {
//     setdeleteid(id);
//     setdeletename(order_no);
//     setDeleteShowModals(true);
//   };

//   const handleCloseModal = () => {
//     setDeleteShowModals(false);
//   };

//   const handleDelete = async () => {
//     try {
//       setLoading(true);
//       await axios.delete(`${ApiUrl}/Api/orders.php/${getdeleteid}`);
//       toast.success("Order deleted successfully!", 3000, "topRight");
//       setDeleteShowModals(false);
//       fetchData();
//     } catch (error) {
//       console.error("Error deleting data:", error.message);
//       toast.error("Failed to delete order", 3000, "topRight");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Search and filter data
//   const filteredData = responseData.filter((item) => {
//     const searchLower = searchTerm.toLowerCase();
//     const orderBy = (item.order_by || "").toLowerCase().trim();
//     const isInTab =
//       activeTab === "by-customer"
//         ? orderBy.includes("customer") || orderBy === "by customer"
//         : orderBy.includes("shop") || orderBy === "by shop";

//     return (
//       isInTab &&
//       (item.order_no?.toLowerCase().includes(searchLower) ||
//         item.customer_info?.name?.toLowerCase().includes(searchLower) ||
//         item.order_items[0]?.product?.toLowerCase().includes(searchLower) ||
//         item.order_items[0]?.category?.toLowerCase().includes(searchLower))
//     );
//   });

//   // Pagination logic
//   const totalItems = filteredData.length;
//   const totalPages = showAllItems ? 1 : Math.ceil(totalItems / itemsPerPage);
//   const currentItems = showAllItems
//     ? filteredData
//     : filteredData.slice(
//         (currentPage - 1) * itemsPerPage,
//         currentPage * itemsPerPage
//       );

//   const handlePageChange = (page) => {
//     if (page < 1 || page > totalPages) return;
//     setCurrentPage(page);
//   };

//   const handleItemsPerPageChange = (e) => {
//     const value = e.target.value;
//     if (value === "All") {
//       setShowAllItems(true);
//       setCurrentPage(1);
//     } else {
//       setShowAllItems(false);
//       setItemsPerPage(Number(value));
//       setCurrentPage(1);
//     }
//   };

//   // Render pagination page numbers
//   const renderPageNumbers = () => {
//     const pages = [];
//     const maxVisiblePages = 2;
//     let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
//     let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

//     if (endPage - startPage + 1 < maxVisiblePages) {
//       startPage = Math.max(1, endPage - maxVisiblePages + 1);
//     }

//     if (startPage > 1) {
//       pages.push(
//         <li
//           key={1}
//           className={`page-item ${currentPage === 1 ? "active" : ""}`}
//         >
//           <button className="page-link" onClick={() => handlePageChange(1)}>
//             1
//           </button>
//         </li>
//       );
//       if (startPage > 2) {
//         pages.push(
//           <li key="start-ellipsis" className="page-item disabled">
//             <span className="page-link">...</span>
//           </li>
//         );
//       }
//     }

//     for (let i = startPage; i <= endPage; i++) {
//       pages.push(
//         <li
//           key={i}
//           className={`page-item ${currentPage === i ? "active" : ""}`}
//         >
//           <button className="page-link" onClick={() => handlePageChange(i)}>
//             {i}
//           </button>
//         </li>
//       );
//     }

//     if (endPage < totalPages) {
//       if (endPage < totalPages - 1) {
//         pages.push(
//           <li key="end-ellipsis" className="page-item disabled">
//             <span className="page-link">...</span>
//           </li>
//         );
//       }
//       pages.push(
//         <li
//           key={totalPages}
//           className={`page-item ${currentPage === totalPages ? "active" : ""}`}
//         >
//           <button
//             className="page-link"
//             onClick={() => handlePageChange(totalPages)}
//           >
//             {totalPages}
//           </button>
//         </li>
//       );
//     }

//     return pages;
//   };

//   // Export Functions
//   const handlePrint = () => {
//     const printWindow = window.open("", "_blank");
//     const printContent = `
//       <!DOCTYPE html>
//       <html>
//       <head>
//         <title>Orders Report</title>
//         <style>
//           body { font-family: Arial, sans-serif; margin: 20px; }
//           h1 { text-align: center; color: #333; }
//           table { width: 100%; border-collapse: collapse; margin-top: 20px; }
//           th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
//           th { background-color: #f2f2f2; font-weight: bold; }
//           tr:nth-child(even) { background-color: #f9f9f9; }
//           @media print { body { margin: 0; } table { font-size: 12px; } }
//         </style>
//       </head>
//       <body>
//         <h1>Orders Report (${
//           activeTab === "by-customer" ? "By Customer" : "By Shop"
//         })</h1>
//         <p><strong>Total Records:</strong> ${filteredData.length}</p>
//         <p><strong>Generated on:</strong> ${new Date().toLocaleString()}</p>
//         <table>
//           <thead>
//             <tr>
//               <th>S.No</th>
//               <th>Order</th>
//               <th>Customer</th>
//               <th>Item</th>
//               <th>Category</th>
//               <th>Delivery Date</th>
//               <th>Total Amount</th>
//             </tr>
//           </thead>
//           <tbody>
//             ${filteredData
//               .map(
//                 (item, index) => `
//                 <tr>
//                   <td>${index + 1}</td>
//                   <td>${item.order_no || ""}</td>
//                   <td>${item.customer_info?.name || ""}</td>
//                   <td>${item.order_items[0]?.product || ""}</td>
//                   <td>${item.order_items[0]?.category || ""}</td>
//                   <td>${formatDate(item.delivery_date)}</td>
//                   <td>₹${item.total || ""}</td>
//                 </tr>
//               `
//               )
//               .join("")}
//           </tbody>
//         </table>
//       </body>
//       </html>
//     `;
//     printWindow.document.write(printContent);
//     printWindow.document.close();
//     printWindow.focus();
//     setTimeout(() => {
//       printWindow.print();
//       printWindow.close();
//     }, 250);
//     toast.success("Print dialog opened!", 2000, "topRight");
//   };

//   const exportPDF = () => {
//     try {
//       const doc = new jsPDF();
//       doc.setFontSize(20);
//       doc.text(
//         `Orders Report (${
//           activeTab === "by-customer" ? "By Customer" : "By Shop"
//         })`,
//         105,
//         20,
//         { align: "center" }
//       );
//       doc.setFontSize(10);
//       doc.setTextColor(100);
//       doc.text(`Total Records: ${filteredData.length}`, 14, 35);
//       doc.text(`Generated on: ${new Date().toLocaleString()}`, 14, 42);

//       const tableColumn = [
//         "S.No",
//         "Order",
//         "Customer",
//         "Item",
//         "Category",
//         "Delivery Date",
//         "Total Amount",
//       ];
//       const tableRows = filteredData.map((item, index) => [
//         index + 1,
//         item.order_no || "",
//         item.customer_info?.name || "",
//         item.order_items[0]?.product || "",
//         item.order_items[0]?.category || "",
//         formatDate(item.delivery_date),
//         `₹${item.total || ""}`,
//       ]);

//       autoTable(doc, {
//         head: [tableColumn],
//         body: tableRows,
//         startY: 50,
//         theme: "striped",
//         headStyles: {
//           fillColor: [66, 139, 202],
//           textColor: 255,
//           fontStyle: "bold",
//         },
//         bodyStyles: { textColor: 50 },
//         alternateRowStyles: { fillColor: [245, 245, 245] },
//         margin: { top: 50, left: 14, right: 14 },
//         styles: { fontSize: 8, cellPadding: 3 },
//       });

//       doc.save(`orders-report-${new Date().toISOString().split("T")[0]}.pdf`);
//       toast.success("PDF exported successfully!", 3000, "topRight");
//     } catch (error) {
//       console.error("Error generating PDF:", error);
//       toast.error("Failed to export PDF", 3000, "topRight");
//     }
//   };

//   const copyToClipboard = () => {
//     try {
//       const headers =
//         "S.No\tOrder\tCustomer\tItem\tCategory\tDelivery Date\tTotal Amount\n";
//       const rows = filteredData
//         .map(
//           (item, index) =>
//             `${index + 1}\t${item.order_no || ""}\t${
//               item.customer_info?.name || ""
//             }\t${item.order_items[0]?.product || ""}\t${
//               item.order_items[0]?.category || ""
//             }\t${formatDate(item.delivery_date)}\t₹${item.total || ""}`
//         )
//         .join("\n");

//       const clipboardData = headers + rows;
//       navigator.clipboard
//         .writeText(clipboardData)
//         .then(() =>
//           toast.success("Data copied to clipboard!", 3000, "topRight")
//         )
//         .catch(() => fallbackCopyTextToClipboard(clipboardData));
//     } catch (error) {
//       console.error("Error copying to clipboard:", error);
//       toast.error("Failed to copy data", 3000, "topRight");
//     }
//   };

//   const fallbackCopyTextToClipboard = (text) => {
//     const textArea = document.createElement("textarea");
//     textArea.value = text;
//     textArea.style.position = "fixed";
//     document.body.appendChild(textArea);
//     textArea.focus();
//     textArea.select();
//     try {
//       document.execCommand("copy");
//       toast.success("Data copied to clipboard!", 3000, "topRight");
//     } catch (err) {
//       toast.error("Failed to copy data", 3000, "topRight");
//     }
//     document.body.removeChild(textArea);
//   };

//   const exportCSV = () => {
//     try {
//       const headers = [
//         "S.No",
//         "Order",
//         "Customer",
//         "Item",
//         "Category",
//         "Delivery Date",
//         "Total Amount",
//       ];
//       const csvData = [
//         headers,
//         ...filteredData.map((item, index) => [
//           index + 1,
//           item.order_no || "",
//           item.customer_info?.name || "",
//           item.order_items[0]?.product || "",
//           item.order_items[0]?.category || "",
//           formatDate(item.delivery_date),
//           `₹${item.total || ""}`,
//         ]),
//       ];

//       const csvContent = csvData
//         .map((row) =>
//           row
//             .map((field) => {
//               if (
//                 typeof field === "string" &&
//                 (field.includes(",") ||
//                   field.includes('"') ||
//                   field.includes("\n"))
//               ) {
//                 return `"${field.replace(/"/g, '""')}"`;
//               }
//               return field;
//             })
//             .join(",")
//         )
//         .join("\n");

//       const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//       const link = document.createElement("a");
//       const url = URL.createObjectURL(blob);
//       link.setAttribute("href", url);
//       link.setAttribute(
//         "download",
//         `orders-report-${new Date().toISOString().split("T")[0]}.csv`
//       );
//       link.style.visibility = "hidden";
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       toast.success("CSV exported successfully!", 3000, "topRight");
//     } catch (error) {
//       console.error("Error exporting CSV:", error);
//       toast.error("Failed to export CSV", 3000, "topRight");
//     }
//   };

//   const exportExcel = () => {
//     try {
//       const headers = [
//         "S.No",
//         "Order",
//         "Customer",
//         "Item",
//         "Category",
//         "Delivery Date",
//         "Total Amount",
//       ];
//       const excelData = [
//         headers,
//         ...filteredData.map((item, index) => [
//           index + 1,
//           item.order_no || "",
//           item.customer_info?.name || "",
//           item.order_items[0]?.product || "",
//           item.order_items[0]?.category || "",
//           formatDate(item.delivery_date),
//           `₹${item.total || ""}`,
//         ]),
//       ];

//       const worksheet = XLSX.utils.aoa_to_sheet(excelData);
//       worksheet["!cols"] = [
//         { wch: 8 },
//         { wch: 15 },
//         { wch: 25 },
//         { wch: 20 },
//         { wch: 15 },
//         { wch: 15 },
//         { wch: 15 },
//       ];

//       const headerRange = XLSX.utils.decode_range(worksheet["!ref"]);
//       for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
//         const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
//         if (!worksheet[cellAddress]) continue;
//         worksheet[cellAddress].s = {
//           font: { bold: true },
//           fill: { fgColor: { rgb: "4F81BD" } },
//           alignment: { horizontal: "center" },
//         };
//       }

//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");
//       workbook.Props = {
//         Title: "Orders Report",
//         Subject: "Order Data Export",
//         Author: "Order Management System",
//         CreatedDate: new Date(),
//       };

//       XLSX.writeFile(
//         workbook,
//         `orders-report-${new Date().toISOString().split("T")[0]}.xlsx`
//       );
//       toast.success("Excel exported successfully!", 3000, "topRight");
//     } catch (error) {
//       console.error("Error exporting Excel:", error);
//       toast.error("Failed to export Excel", 3000, "topRight");
//     }
//   };

//   return (
//     <>
//       {loading && (
//         <div className="loading-overlay">
//           <div className="loading-message">
//             <div className="loadinggif"></div>
//           </div>
//         </div>
//       )}

//       <div className="container-fluid mb-5">
//         {/* Header */}
//         <div className="d-flex mb-2">
//           <h6 className="card-title m-2">Order</h6>
//           <button
//             className="btn btn-primary btn-sm rounded-3"
//             onClick={() => navigate("/add-order")}
//           >
//             Add <span className="ms-2">+</span>
//           </button>
//         </div>

//         {/* Tabs */}
//         <div className="card shadow-sm border-0 rounded-3 mb-2">
//           <div className="row p-2">
//             <div className="col-auto">
//               <button
//                 className={`btn btn-link text-decoration-none px-3 ${
//                   activeTab === "by-customer"
//                     ? "text-white bg-primary"
//                     : "text-dark"
//                 }`}
//                 onClick={() => handleTabClick("by-customer")}
//               >
//                 <span style={{ fontSize: "13px" }}>By Customer</span>
//               </button>
//               <button
//                 className={`btn btn-link text-decoration-none px-3 ms-3 ${
//                   activeTab === "by-shop"
//                     ? "text-white bg-primary"
//                     : "text-dark"
//                 }`}
//                 onClick={() => handleTabClick("by-shop")}
//               >
//                 <span style={{ fontSize: "13px" }}>By Shop</span>
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Main Content */}
//         <div className="card shadow-sm">
//           <div className="card-body">
//             <div className="d-flex justify-content-between align-items-center mb-3">
//               {/* Show per page */}
//               <div className="d-flex align-items-center">
//                 <label className="form-label text-dark mt-2 me-2">Show:</label>
//                 <select
//                   className="form-control"
//                   style={{ width: "100px" }}
//                   onChange={handleItemsPerPageChange}
//                   value={showAllItems ? "All" : itemsPerPage}
//                 >
//                   <option value="All">All</option>
//                   {[5, 10, 20, 100, 200, 500, 1000].map((pageSize) => (
//                     <option key={pageSize} value={pageSize}>
//                       {pageSize}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               {/* Export buttons */}
//               <div className="d-flex">
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1"
//                   onClick={handlePrint}
//                 >
//                   Print
//                 </button>
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1"
//                   onClick={exportPDF}
//                 >
//                   PDF
//                 </button>
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1"
//                   onClick={copyToClipboard}
//                 >
//                   Copy
//                 </button>
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1"
//                   onClick={exportCSV}
//                 >
//                   CSV
//                 </button>
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1"
//                   onClick={exportExcel}
//                 >
//                   Excel
//                 </button>
//               </div>

//               {/* Search */}
//               <div className="search-container">
//                 <input
//                   type="text"
//                   className="form-control"
//                   placeholder="Search"
//                   value={searchTerm}
//                   onChange={(e) => {
//                     setSearchTerm(e.target.value);
//                     setCurrentPage(1);
//                   }}
//                 />
//               </div>
//             </div>

//             {/* Table */}
//             <div className="card tableCard p-2">
//               <div className="table-container">
//                 <table className="table table-layout-fixed w-100">
//                   <thead className="bg-light">
//                     <tr>
//                       <th>S.No</th>
//                       <th>Order</th>
//                       <th>Customer</th>
//                       <th>Item</th>
//                       <th>Category</th>
//                       <th>Delivery Date</th>
//                       <th>Total Amount</th>
//                       <th>Actions</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {currentItems.length > 0 ? (
//                       currentItems.map((item, index) => (
//                         <tr key={item.id}>
//                           <td>
//                             {(currentPage - 1) * itemsPerPage + index + 1}
//                           </td>
//                           <td>{item.order_no || "N/A"}</td>
//                           <td>{item.customer_info?.name || "N/A"}</td>
//                           <td>{item.order_items[0]?.product || "N/A"}</td>
//                           <td>{item.order_items[0]?.category || "N/A"}</td>
//                           <td>{formatDate(item.delivery_date)}</td>
//                           <td>₹{item.total || "0"}</td>
//                           <td>
//                             <button
//                               className="btn btn-sm btn-light me-1"
//                               onClick={() => handleUpdateOrder(item.id)}
//                             >
//                               <i className="fa-solid fa-pen-to-square text-primary"></i>
//                             </button>
//                             <button
//                               className="btn btn-sm btn-light"
//                               onClick={() =>
//                                 handleOpenModal(item.id, item.order_no)
//                               }
//                             >
//                               <i className="fa-solid fa-trash text-danger"></i>
//                             </button>
//                           </td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         <td colSpan="8" className="text-center">
//                           No data available
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>

//             {/* Pagination */}
//             <div className="row mt-3">
//               <div className="col-lg-6">
//                 <p className="text-muted">
//                   Showing{" "}
//                   {showAllItems ? 1 : (currentPage - 1) * itemsPerPage + 1} to{" "}
//                   {showAllItems
//                     ? totalItems
//                     : Math.min(currentPage * itemsPerPage, totalItems)}{" "}
//                   of {totalItems} entries
//                 </p>
//               </div>
//               <div className="col-lg-6">
//                 <nav aria-label="Page navigation">
//                   <ul className="pagination justify-content-end">
//                     <li
//                       className={`page-item ${
//                         currentPage === 1 ? "disabled" : ""
//                       }`}
//                     >
//                       <button
//                         className="page-link"
//                         onClick={() => handlePageChange(1)}
//                       >
//                         ««
//                       </button>
//                     </li>
//                     <li
//                       className={`page-item ${
//                         currentPage === 1 ? "disabled" : ""
//                       }`}
//                     >
//                       <button
//                         className="page-link"
//                         onClick={() => handlePageChange(currentPage - 1)}
//                       >
//                         «
//                       </button>
//                     </li>
//                     {renderPageNumbers()}
//                     <li
//                       className={`page-item ${
//                         currentPage === totalPages || totalPages === 0
//                           ? "disabled"
//                           : ""
//                       }`}
//                     >
//                       <button
//                         className="page-link"
//                         onClick={() => handlePageChange(currentPage + 1)}
//                       >
//                         »
//                       </button>
//                     </li>
//                     <li
//                       className={`page-item ${
//                         currentPage === totalPages || totalPages === 0
//                           ? "disabled"
//                           : ""
//                       }`}
//                     >
//                       <button
//                         className="page-link"
//                         onClick={() => handlePageChange(totalPages)}
//                       >
//                         »»
//                       </button>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Delete Confirmation Modal */}
//       {deleteShowModals && (
//         <div
//           className="modal fade show"
//           style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
//           tabIndex="-1"
//           aria-labelledby="deleteConfirmModalLabel"
//           aria-modal="true"
//         >
//           <div className="modal-dialog modal-dialog-centered">
//             <div className="modal-content">
//               <div className="modal-body text-center">
//                 <div
//                   className="icon-box d-flex justify-content-center align-items-center bg-light rounded-circle mb-3"
//                   style={{ width: "80px", height: "80px", margin: "0 auto" }}
//                 >
//                   <i className="bi bi-exclamation-triangle text-danger fs-2"></i>
//                 </div>
//                 <h4 className="modal-title mb-3">Are you sure?</h4>
//                 <h6 className="mb-4">
//                   Do you really want to delete this{" "}
//                   <span className="text-primary">({getdeletename})</span>?
//                 </h6>
//                 <div className="d-flex justify-content-center">
//                   <button
//                     className="btn btn-secondary btn-sm mx-2"
//                     onClick={handleCloseModal}
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     className="btn btn-danger btn-sm mx-2"
//                     onClick={handleDelete}
//                   >
//                     Delete
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       {deleteShowModals && <div className="modal-backdrop fade show"></div>}
//     </>
//   );
// }

// export default Order;


import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "../Toast/ToastContext";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ApiUrl from "./../Environment/ApiUrl";
import "../../assets/css/Loader.css";

function Order() {
  const navigate = useNavigate();
  const toast = useToast();

  // State management
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("by-customer");
  const [responseData, setResponseData] = useState([]);
  const [deleteShowModals, setDeleteShowModals] = useState(false);
  const [getdeleteid, setdeleteid] = useState("");
  const [getdeletename, setdeletename] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showAllItems, setShowAllItems] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showNotificationModal, setShowNotificationModal] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [actionType, setActionType] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [notifications, setNotifications] = useState([]);

  // Fetch notifications
  const fetchNotifications = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/notification.php`);
      setNotifications(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching notifications:", error.message);
      toast.error("Failed to fetch notifications", 3000, "topRight");
    }
  };

  // Check if a notification for the action is accepted
  const checkNotificationStatus = (orderId, buttonValue) => {
    const userId = localStorage.getItem("username");
    return notifications.some(
      (notif) =>
        notif.table_id === orderId.toString() &&
        notif.button_value === buttonValue &&
        notif.status === "accepted" &&
        notif.employe_id === userId &&
        notif.viewed === "false"
    );
  };

  // Check if a notification for the action is pending
  const hasPendingNotification = (orderId, buttonValue) => {
    const userId = localStorage.getItem("username");
    return notifications.some(
      (notif) =>
        notif.table_id === orderId.toString() &&
        notif.button_value === buttonValue &&
        notif.status === "requested" &&
        notif.employe_id === userId &&
        notif.viewed === "false"
    );
  };

  // Handle notification submission
  const handleNotificationSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (isSubmitting) return;
    setIsSubmitting(true);

    if (hasPendingNotification(selectedOrderId, actionType)) {
      toast.warning(
        "A pending request for this action already exists!",
        3000,
        "topRight"
      );
      closeNotificationModal();
      return;
    }

    try {
      const userId = localStorage.getItem("username");
      const currentTime = new Date()
        .toISOString()
        .slice(0, 19)
        .replace("T", " ");

      const formData = {
        table_name: "orders",
        table_id: selectedOrderId,
        employe_id: userId || "",
        status: "requested",
        button_value: actionType,
        time: currentTime,
        viewed: "false",
        created_date: currentTime,
        updated_by: userId || "",
        updated_date: currentTime,
      };

      await axios.post(`${ApiUrl}/Api/notification.php`, formData, {
        headers: { "Content-Type": "application/json" },
      });

      toast.success(
        `${actionType} request sent successfully!`,
        3000,
        "topRight"
      );
      closeNotificationModal();
      fetchNotifications();
    } catch (error) {
      console.error("Error submitting notification:", error.message);
      toast.error(
        "Error submitting notification. Please try again.",
        3000,
        "topRight"
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  // Close notification modal
  const closeNotificationModal = () => {
    setShowNotificationModal(false);
    setSelectedOrderId(null);
    setActionType("");
    setIsSubmitting(false);
  };

 // Fetch data
const fetchData = async () => {
  try {
    setLoading(true);
    const localRole = localStorage.getItem("role");
    const localUsername = localStorage.getItem("username");
    const response = await axios.get(
      localRole === "Employee"
        ? `${ApiUrl}/Api/orders.php?employee_id=${localUsername}`
        : `${ApiUrl}/Api/orders.php`
    );

    // Reverse the data if needed
    const reversedData = (response.data?.data || []).reverse();

    // Deduplicate based on unique id to prevent repeated entries
    const uniqueData = reversedData.filter(
      (value, index, self) => self.findIndex(v => v.id === value.id) === index
    );

    setResponseData(uniqueData);

  } catch (error) {
    console.error("Error fetching data:", error.message);
    setResponseData([]);
    toast.error("Failed to fetch data", 3000, "topRight");
  } finally {
    setLoading(false);
  }
};



  const handleprint = (id, order_no) => {
    // Navigate to dynamic route
    navigate(`/order-big-bill/${order_no}`);
  };


  // Format date to DD-MM-YYYY
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Handle tab switching
  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setCurrentPage(1);
  };

  // Handle update order
  const handleUpdateOrder = (id) => {
    const userRole = localStorage.getItem("role");
    const order = responseData.find((item) => item.id === id);

    if (userRole === "Employee") {
      if (checkNotificationStatus(id, "Edit")) {
        navigate(`/update-order/${id}`);
      } else {
        setSelectedOrderId(id);
        setActionType("Edit");
        setShowNotificationModal(true);
      }
    } else {
      navigate(`/update-order/${id}`);
    }
  };

  // Delete functionality
  const handleOpenModal = (id, order_no) => {
    const userRole = localStorage.getItem("role");

    if (userRole === "Employee") {
      if (checkNotificationStatus(id, "Delete")) {
        setdeleteid(id);
        setdeletename(order_no);
        setDeleteShowModals(true);
      } else {
        setSelectedOrderId(id);
        setActionType("Delete");
        setShowNotificationModal(true);
      }
    } else {
      setdeleteid(id);
      setdeletename(order_no);
      setDeleteShowModals(true);
    }
  };

  const handleCloseModal = () => {
    setDeleteShowModals(false);
    setdeleteid("");
    setdeletename("");
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      await axios.delete(`${ApiUrl}/Api/orders.php/${getdeleteid}`);

      const notification = notifications.find(
        (notif) =>
          notif.table_id === getdeleteid.toString() &&
          notif.button_value === "Delete" &&
          notif.viewed === "false"
      );
      if (notification) {
        const currentTime = new Date()
          .toISOString()
          .slice(0, 19)
          .replace("T", " ");
        const notificationPayload = {
          id: notification.id,
          viewed: "true",
          updated_by: localStorage.getItem("username"),
          updated_date: currentTime,
          table_name: notification.table_name,
          table_id: notification.table_id,
          employe_id: notification.employe_id,
          status: notification.status,
          button_value: notification.button_value,
          time: notification.time,
          created_date: notification.created_date,
        };

        await axios.put(
          `${ApiUrl}/Api/notification.php/${notification.id}`,
          notificationPayload,
          {
            headers: { "Content-Type": "application/json" },
          }
        );
      }

      toast.success("Order deleted successfully!", 3000, "topRight");
      handleCloseModal();
      fetchData();
      fetchNotifications();
    } catch (error) {
      console.error("Error deleting data:", error.message);
      toast.error("Failed to delete order", 3000, "topRight");
    } finally {
      setLoading(false);
    }
  };

  // Search and filter data
  const filteredData = responseData.filter((item) => {
    const searchLower = searchTerm.toLowerCase();
    const orderBy = (item.order_by || "").toLowerCase().trim();
    const isInTab =
      activeTab === "by-customer"
        ? orderBy.includes("customer") || orderBy === "by customer"
        : orderBy.includes("shop") || orderBy === "by shop";

    return (
      isInTab &&
      (item.order_no?.toLowerCase().includes(searchLower) ||
        item.customer_info?.name?.toLowerCase().includes(searchLower) ||
        item.order_items[0]?.product?.toLowerCase().includes(searchLower) ||
        item.order_items[0]?.category?.toLowerCase().includes(searchLower))
    );
  });

  // Pagination logic
  const totalItems = filteredData.length;
  const totalPages = showAllItems ? 1 : Math.ceil(totalItems / itemsPerPage);
  const currentItems = showAllItems
    ? filteredData
    : filteredData.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      );

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (e) => {
    const value = e.target.value;
    if (value === "All") {
      setShowAllItems(true);
      setCurrentPage(1);
    } else {
      setShowAllItems(false);
      setItemsPerPage(Number(value));
      setCurrentPage(1);
    }
  };

  // Render pagination page numbers
  const renderPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 2;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    if (startPage > 1) {
      pages.push(
        <li
          key={1}
          className={`page-item ${currentPage === 1 ? "active" : ""}`}
        >
          <button className="page-link" onClick={() => handlePageChange(1)}>
            1
          </button>
        </li>
      );
      if (startPage > 2) {
        pages.push(
          <li key="start-ellipsis" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li
          key={i}
          className={`page-item ${currentPage === i ? "active" : ""}`}
        >
          <button className="page-link" onClick={() => handlePageChange(i)}>
            {i}
          </button>
        </li>
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pages.push(
          <li key="end-ellipsis" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
      pages.push(
        <li
          key={totalPages}
          className={`page-item ${currentPage === totalPages ? "active" : ""}`}
        >
          <button
            className="page-link"
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </button>
        </li>
      );
    }

    return pages;
  };

  // Export Functions
  const handlePrint = () => {
    try {
      const printWindow = window.open("", "_blank");
      printWindow.document.write(`
        <html>
        <head>
          <title>Orders Report</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            h1 { text-align: center; color: #333; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
            th { background-color: #f2f2f2; font-weight: bold; }
            .table-secondary { background-color: #e2e3e5; }
            .table-danger { background-color: #f8d7da; }
            .table-info { background-color: #cff4fc; }
          </style>
        </head>
        <body>
          <h1>Orders Report (${
            activeTab === "by-customer" ? "By Customer" : "By Shop"
          })</h1>
          <p><strong>Total Records:</strong> ${filteredData.length}</p>
          <p><strong>Generated on:</strong> ${new Date().toLocaleString()}</p>
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Order</th>
                <th>Customer</th>
                <th>Item</th>
                <th>Category</th>
                <th>Delivery Date</th>
                <th>Total Amount</th>
              </tr>
            </thead>
            <tbody>
              ${filteredData
                .map((item, index) => {
                  const userId = localStorage.getItem("username");
                  const notification = notifications.find(
                    (notif) =>
                      notif.table_id === item.id.toString() &&
                      notif.employe_id === userId &&
                      notif.viewed === "false"
                  );
                  let rowClass = "";
                  if (notification) {
                    switch (notification.status) {
                      case "accepted":
                        rowClass = "table-secondary";
                        break;
                      case "rejected":
                        rowClass = "table-danger";
                        break;
                      case "requested":
                        rowClass = "table-info";
                        break;
                    }
                  }
                  return `
                    <tr class="${rowClass}">
                      <td>${index + 1}</td>
                      <td>${item.order_no || ""}</td>
                      <td>${item.customer_info?.name || ""}</td>
                      <td>${item.order_items[0]?.product || ""}</td>
                      <td>${item.order_items[0]?.category || ""}</td>
                      <td>${formatDate(item.delivery_date)}</td>
                      <td>₹${item.total || ""}</td>
                    </tr>
                  `;
                })
                .join("")}
            </tbody>
          </table>
        </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
      toast.success("Print dialog opened!", 3000, "topRight");
    } catch (error) {
      console.error("Error printing:", error);
      toast.error("Error printing. Please try again", 3000, "topRight");
    }
  };

  const exportPDF = () => {
    try {
      const doc = new jsPDF();
      doc.setFontSize(20);
      doc.text(
        `Orders Report (${
          activeTab === "by-customer" ? "By Customer" : "By Shop"
        })`,
        105,
        20,
        { align: "center" }
      );
      doc.setFontSize(10);
      doc.setTextColor(100);
      doc.text(`Total Records: ${filteredData.length}`, 14, 35);
      doc.text(`Generated on: ${new Date().toLocaleString()}`, 14, 42);

      const tableColumn = [
        "S.No",
        "Order",
        "Customer",
        "Item",
        "Category",
        "Delivery Date",
        "Total Amount",
      ];
      const tableRows = filteredData.map((item, index) => {
        const userId = localStorage.getItem("username");
        const notification = notifications.find(
          (notif) =>
            notif.table_id === item.id.toString() &&
            notif.employe_id === userId &&
            notif.viewed === "false"
        );
        let rowStyle = {};
        if (notification) {
          switch (notification.status) {
            case "accepted":
              rowStyle = { fillColor: [226, 227, 229] };
              break;
            case "rejected":
              rowStyle = { fillColor: [248, 215, 218] };
              break;
            case "requested":
              rowStyle = { fillColor: [207, 244, 252] };
              break;
          }
        }
        return [
          index + 1,
          item.order_no || "",
          item.customer_info?.name || "",
          item.order_items[0]?.product || "",
          item.order_items[0]?.category || "",
          formatDate(item.delivery_date),
          `₹${item.total || ""}`,
          rowStyle,
        ];
      });

      autoTable(doc, {
        head: [tableColumn],
        body: tableRows.map((row) => row.slice(0, -1)),
        startY: 50,
        theme: "striped",
        headStyles: {
          fillColor: [66, 139, 202],
          textColor: 255,
          fontStyle: "bold",
        },
        bodyStyles: { textColor: 50 },
        margin: { top: 50, left: 14, right: 14 },
        styles: { fontSize: 8, cellPadding: 3 },
        didParseCell: (data) => {
          if (data.section === "body") {
            const rowIndex = data.row.index;
            const rowStyle =
              tableRows[rowIndex][tableRows[rowIndex].length - 1];
            if (rowStyle) {
              data.cell.styles = { ...data.cell.styles, ...rowStyle };
            }
          }
        },
      });

      doc.save(`orders-report-${new Date().toISOString().split("T")[0]}.pdf`);
      toast.success("PDF exported successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error generating PDF:", error);
      toast.error("Failed to export PDF", 3000, "topRight");
    }
  };

  const copyToClipboard = () => {
    try {
      const headers =
        "S.No\tOrder\tCustomer\tItem\tCategory\tDelivery Date\tTotal Amount\n";
      const rows = filteredData
        .map(
          (item, index) =>
            `${index + 1}\t${item.order_no || ""}\t${
              item.customer_info?.name || ""
            }\t${item.order_items[0]?.product || ""}\t${
              item.order_items[0]?.category || ""
            }\t${formatDate(item.delivery_date)}\t₹${item.total || ""}`
        )
        .join("\n");

      const clipboardData = headers + rows;
      navigator.clipboard
        .writeText(clipboardData)
        .then(() =>
          toast.success("Data copied to clipboard!", 3000, "topRight")
        )
        .catch(() => fallbackCopyTextToClipboard(clipboardData));
    } catch (error) {
      console.error("Error copying to clipboard:", error);
      toast.error("Failed to copy data", 3000, "topRight");
    }
  };

  const fallbackCopyTextToClipboard = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand("copy");
      toast.success("Data copied to clipboard!", 3000, "topRight");
    } catch (err) {
      toast.error("Failed to copy data", 3000, "topRight");
    }
    document.body.removeChild(textArea);
  };

  const exportCSV = () => {
    try {
      const headers = [
        "S.No",
        "Order",
        "Customer",
        "Item",
        "Category",
        "Delivery Date",
        "Total Amount",
      ];
      const csvData = [
        headers,
        ...filteredData.map((item, index) => [
          index + 1,
          item.order_no || "",
          item.customer_info?.name || "",
          item.order_items[0]?.product || "",
          item.order_items[0]?.category || "",
          formatDate(item.delivery_date),
          `₹${item.total || ""}`,
        ]),
      ];

      const csvContent = csvData
        .map((row) =>
          row
            .map((field) => {
              if (
                typeof field === "string" &&
                (field.includes(",") ||
                  field.includes('"') ||
                  field.includes("\n"))
              ) {
                return `"${field.replace(/"/g, '""')}"`;
              }
              return field;
            })
            .join(",")
        )
        .join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `orders-report-${new Date().toISOString().split("T")[0]}.csv`
      );
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success("CSV exported successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error exporting CSV:", error);
      toast.error("Failed to export CSV", 3000, "topRight");
    }
  };

  const exportExcel = () => {
    try {
      const headers = [
        "S.No",
        "Order",
        "Customer",
        "Item",
        "Category",
        "Delivery Date",
        "Total Amount",
      ];
      const excelData = filteredData.map((item, index) => ({
        "S.No": index + 1,
        Order: item.order_no || "",
        Customer: item.customer_info?.name || "",
        Item: item.order_items[0]?.product || "",
        Category: item.order_items[0]?.category || "",
        "Delivery Date": formatDate(item.delivery_date),
        "Total Amount": `₹${item.total || ""}`,
      }));

      const worksheet = XLSX.utils.json_to_sheet(excelData);
      worksheet["!cols"] = [
        { wch: 8 },
        { wch: 15 },
        { wch: 25 },
        { wch: 20 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
      ];

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");
      workbook.Props = {
        Title: "Orders Report",
        Subject: "Order Data Export",
        Author: "Order Management System",
        CreatedDate: new Date(),
      };

      XLSX.writeFile(
        workbook,
        `orders-report-${new Date().toISOString().split("T")[0]}.xlsx`
      );
      toast.success("Excel exported successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error exporting Excel:", error);
      toast.error("Failed to export Excel", 3000, "topRight");
    }
  };

  // Periodic data fetching
  useEffect(() => {
    fetchData();
    fetchNotifications();
    const interval = setInterval(() => {
      fetchData();
      fetchNotifications();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {/* {loading && (
        <div className="loading-overlay">
          <div className="loading-message">
            <div className="loadinggif"></div>
          </div>
        </div>
      )} */}

      <div className="container-fluid mb-5">
        {/* Header */}
        <div className="d-flex mb-2">
          <h6 className="card-title m-2">Orders</h6>
          <button
            className="btn btn-primary btn-sm rounded-3"
            onClick={() => navigate("/add-order")}
          >
            Add <span className="ms-2">+</span>
          </button>
        </div>

        {/* Tabs */}
        <div className="card shadow-sm border-0 rounded-3 mb-2">
          <div className="row p-2">
            <div className="col-auto">
              <button
                className={`btn btn-link text-decoration-none px-3 ${
                  activeTab === "by-customer"
                    ? "text-white bg-primary"
                    : "text-dark"
                }`}
                onClick={() => handleTabClick("by-customer")}
              >
                <span style={{ fontSize: "13px" }}>By Customer</span>
              </button>
              <button
                className={`btn btn-link text-decoration-none px-3 ms-3 ${
                  activeTab === "by-shop"
                    ? "text-white bg-primary"
                    : "text-dark"
                }`}
                onClick={() => handleTabClick("by-shop")}
              >
                <span style={{ fontSize: "13px" }}>By Shop</span>
              </button>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="card shadow-sm">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-3">
              {/* Show per page */}
              <div className="d-flex align-items-center">
                <label className="form-label text-dark mt-2 me-2">Show:</label>
                <select
                  className="form-control"
                  style={{ width: "100px" }}
                  onChange={handleItemsPerPageChange}
                  value={showAllItems ? "All" : itemsPerPage}
                >
                  <option value="All">All</option>
                  {[5, 10, 20, 100, 200, 500, 1000].map((pageSize) => (
                    <option key={pageSize} value={pageSize}>
                      {pageSize}
                    </option>
                  ))}
                </select>
              </div>

              {/* Export buttons */}
              <div className="d-flex">
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={handlePrint}
                >
                  Print
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportPDF}
                >
                  PDF
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={copyToClipboard}
                >
                  Copy
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportCSV}
                >
                  CSV
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportExcel}
                >
                  Excel
                </button>
              </div>

              {/* Search */}
              <div className="search-container">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setCurrentPage(1);
                  }}
                />
              </div>
            </div>

            {/* Table */}
            <div className="card tableCard p-2">
              <div className="table-container">
                <table className="table table-layout-fixed w-100">
                  <thead className="bg-light">
                    <tr>
                      <th>S.No</th>
                      <th>Order ID</th>
                      <th>Customer Name</th>
                      <th>Item</th>
                      <th>Category</th>
                      <th>Delivery Date</th>
                      <th>Total Amount</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.length > 0 ? (
                      currentItems.map((item, index) => {
                        const userId = localStorage.getItem("username");
                        const notification = notifications.find(
                          (notif) =>
                            notif.table_id === item.id.toString() &&
                            notif.viewed === "false"
                        );
                        let rowClass = "";
                        if (notification) {
                          switch (notification.status) {
                            case "accepted":
                              rowClass = "table-secondary";
                              break;
                            case "rejected":
                              rowClass = "table-danger";
                              break;
                            case "requested":
                              rowClass = "table-info";
                              break;
                          }
                        }
                        return (
                          <tr key={item.id} className={rowClass}>
                            <td>
                              {(currentPage - 1) * itemsPerPage + index + 1}
                            </td>
                            <td>{item.order_no || "N/A"}</td>
                            <td>{item.customer_info?.name || "N/A"}</td>
                            <td>{item.order_items[0]?.product || "N/A"}</td>
                            <td>{item.order_items[0]?.category || "N/A"}</td>
                            <td>{formatDate(item.delivery_date)}</td>
                            <td>₹{item.total || "0"}</td>
                            <td>
                              <button
                                className="btn btn-sm btn-light me-1"
                                onClick={() => handleUpdateOrder(item.id)}
                              >
                                <i className="fa-solid fa-pen-to-square text-primary"></i>
                              </button>
                                   <button
                              className="btn btn-sm btn-light"
                              onClick={() =>
                                handleprint(item.id, item.order_no)
                              }
                            >
                              <i className="fa-solid fa-print text-secondary fs-6"></i>
                            </button>
                              <button
                                className="btn btn-sm btn-light"
                                onClick={() =>
                                  handleOpenModal(item.id, item.order_no)
                                }
                              >
                                <i className="fa-solid fa-trash text-danger"></i>
                              </button>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-center">
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Pagination */}
            <div className="row mt-3">
              <div className="col-lg-6">
                <p className="text-muted">
                  Showing{" "}
                  {showAllItems ? 1 : (currentPage - 1) * itemsPerPage + 1} to{" "}
                  {showAllItems
                    ? totalItems
                    : Math.min(currentPage * itemsPerPage, totalItems)}{" "}
                  of {totalItems} entries
                </p>
              </div>
              <div className="col-lg-6">
                <nav aria-label="Page navigation">
                  <ul className="pagination justify-content-end">
                    <li
                      className={`page-item ${
                        currentPage === 1 ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(1)}
                      >
                        ««
                      </button>
                    </li>
                    <li
                      className={`page-item ${
                        currentPage === 1 ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(currentPage - 1)}
                      >
                        «
                      </button>
                    </li>
                    {renderPageNumbers()}
                    <li
                      className={`page-item ${
                        currentPage === totalPages || totalPages === 0
                          ? "disabled"
                          : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(currentPage + 1)}
                      >
                        »
                      </button>
                    </li>
                    <li
                      className={`page-item ${
                        currentPage === totalPages || totalPages === 0
                          ? "disabled"
                          : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(totalPages)}
                      >
                        »»
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Notification Modal */}
      <div
        className={`modal fade ${showNotificationModal ? "show" : ""}`}
        style={{
          display: showNotificationModal ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
        aria-labelledby="notificationModalLabel"
        aria-hidden={!showNotificationModal}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h6
                className="modal-title text-primary"
                id="notificationModalLabel"
              >
                Send {actionType} Request to Admin
              </h6>
              <button
                type="button"
                className="btn-close"
                style={{ fontSize: "10px" }}
                onClick={closeNotificationModal}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleNotificationSubmit}>
                <p className="text-center">
                  Do you want to request to {actionType.toLowerCase()} this
                  order?
                </p>
                <div className="text-center mt-4">
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm px-4 me-2"
                    onClick={closeNotificationModal}
                  >
                    No
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary btn-sm px-4"
                    disabled={isSubmitting}
                  >
                    Yes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      {deleteShowModals && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
          aria-labelledby="deleteConfirmModalLabel"
          aria-modal="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body text-center">
                <div
                  className="icon-box d-flex justify-content-center align-items-center bg-light rounded-circle mb-3"
                  style={{ width: "80px", height: "80px", margin: "0 auto" }}
                >
                  <i className="bi bi-exclamation-triangle text-danger fs-2"></i>
                </div>
                <h4 className="modal-title mb-3">Are you sure?</h4>
                <h6 className="mb-4">
                  Do you really want to delete this{" "}
                  <span className="text-primary">({getdeletename})</span>?
                </h6>
                <div className="d-flex justify-content-center">
                  <button
                    className="btn btn-secondary btn-sm mx-2"
                    onClick={handleCloseModal}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-danger btn-sm mx-2"
                    onClick={handleDelete}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {(showNotificationModal || deleteShowModals) && (
        <div className="modal-backdrop fade show"></div>
      )}
    </>
  );
}

export default Order;